import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import * as VueMenu from '@hscmap/vue-menu'
import VModal from 'vue-js-modal'
import vSelect from 'vue-select'
import infiniteScroll from 'vue-infinite-scroll'
import vuetify from './plugins/vuetify'
import VueAceEditor from 'vue2-ace-editor'
import VueConfirmDialog from 'vue-confirm-dialog';
import router from './router'


Vue.config.productionTip = false
Vue.component('v-sel', vSelect)
Vue.component('vue-ace-editor', VueAceEditor)
// Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
Vue.use(infiniteScroll)
Vue.use(VueMenu)
Vue.use(VueConfirmDialog)
Vue.use(VModal, { dynamicDefault: { clickToClose: false, adaptive: true } })

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
